var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarSparkleOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7763.86,-1243.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prayinghands-white",
    transform: "matrix(0.145417,0,0,0.186342,7360.34,1184.37)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.25215,0,0,6.43977,2785.97,328.588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.498,1.754C12.405,1.564 12.211,1.444 12,1.444C11.789,1.444 11.595,1.564 11.502,1.754L8.541,7.752C8.541,7.752 1.92,8.72 1.92,8.72C1.71,8.751 1.537,8.898 1.472,9.099C1.406,9.3 1.461,9.52 1.612,9.668L6.403,14.334C6.403,14.334 5.272,20.926 5.272,20.926C5.237,21.135 5.322,21.345 5.493,21.469C5.665,21.594 5.891,21.61 6.079,21.512L12,18.398C12,18.398 17.921,21.512 17.921,21.512C18.109,21.61 18.335,21.594 18.507,21.469C18.678,21.345 18.763,21.135 18.728,20.926L17.597,14.334C17.597,14.334 22.388,9.668 22.388,9.668C22.539,9.52 22.594,9.3 22.528,9.099C22.463,8.898 22.29,8.751 22.08,8.72L15.459,7.752C15.459,7.752 12.498,1.754 12.498,1.754ZM12,3.255L14.592,8.506C14.673,8.67 14.829,8.783 15.01,8.81L20.806,9.657C20.806,9.657 16.612,13.742 16.612,13.742C16.481,13.87 16.422,14.054 16.452,14.234L17.442,20.004C17.442,20.004 12.259,17.278 12.259,17.278C12.097,17.193 11.903,17.193 11.741,17.278L6.558,20.004C6.558,20.004 7.548,14.234 7.548,14.234C7.578,14.054 7.519,13.87 7.388,13.742L3.194,9.657C3.194,9.657 8.99,8.81 8.99,8.81C9.171,8.783 9.327,8.67 9.408,8.506L12,3.255Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSparkleOff);
export default __webpack_public_path__ + "static/media/star_sparkle_off.4b11dd7c64cd706514a0c475ba905ec0.svg";
export { ForwardRef as ReactComponent };